import { useState, useEffect, useCallback } from 'react';

export default function useGeolocation() {
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const requestLocation = useCallback(() => {
    if (!navigator.geolocation) {
      setError('Geolocalização não é suportada pelo seu navegador');
      return;
    }

    setLoading(true);
    setError(null);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        setLoading(false);
      },
      (err) => {
        switch (err.code) {
          case err.PERMISSION_DENIED:
            setError('Permissão de localização negada. Por favor, habilite nas configurações do navegador.');
            break;
          case err.POSITION_UNAVAILABLE:
            setError('Localização indisponível.');
            break;
          case err.TIMEOUT:
            setError('Tempo esgotado ao obter localização.');
            break;
          default:
            setError('Erro ao obter localização.');
        }
        setLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000,
      }
    );
  }, []);

  const setManualLocation = useCallback((lat, lng) => {
    setLocation({ lat, lng });
    setError(null);
  }, []);

  useEffect(() => {
    // Coordenadas vindas de URL compartilhada têm precedência sobre a geolocalização.
    const params = new URLSearchParams(window.location.search);
    const lat = parseFloat(params.get('lat'));
    const lng = parseFloat(params.get('lng'));
    if (!isNaN(lat) && !isNaN(lng) && lat >= -34 && lat <= 6 && lng >= -74 && lng <= -34) {
      setLocation({ lat, lng });
      return;
    }
    requestLocation();
  }, [requestLocation]);

  return { location, error, loading, requestLocation, setManualLocation };
}
